import { markReceiptCancelVerificationStatus } from "../receiptCancelVerification/receiptCancelVerification";



export const markReceiptCancellationAsApproved: any = (recordId:  string, data:any, args: any[]) => {
  return markReceiptCancelVerificationStatus(recordId, args[0], data, "Successfully approved the canccel request.");
}